export default "__VITE_PUBLIC_ASSET__1425c2d3__"